/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_Meta_TitleInputs */

const id_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik kreasi - egdata.app`)
};

const ms_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik ciptaan - egdata.app`)
};

const da_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelsesstatistik - egdata.app`)
};

const de_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellungsstatistiken - egdata.app`)
};

const en_us2_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creations stats - egdata.app`)
};

const es_es2_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de creaciones - egdata.app`)
};

const es_mx2_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de creaciones - egdata.app`)
};

const fil_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng mga creation - egdata.app`)
};

const fr_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de créations - egdata.app`)
};

const it_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche creazioni - egdata.app`)
};

const hu_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozási statisztikák - egdata.app`)
};

const nl_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatiestatistieken - egdata.app`)
};

const no_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettelsesstatistikk - egdata.app`)
};

const pl_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki tworzenia - egdata.app`)
};

const pt_br2_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de criações - egdata.app`)
};

const pt_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de criações - egdata.app`)
};

const ro_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici creații - egdata.app`)
};

const fi_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontitilastot - egdata.app`)
};

const sv_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapelsestatistik - egdata.app`)
};

const vi_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê sáng tạo - egdata.app`)
};

const tr_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturma istatistikleri - egdata.app`)
};

const cs_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky vytvoření - egdata.app`)
};

const bg_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на създаванията - egdata.app`)
};

const ru_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика созданий — egdata.app`)
};

const uk_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика створень - egdata.app`)
};

const ar_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات الإنشاءات - egdata.app`)
};

const hi_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण आँकड़े - egdata.app`)
};

const th_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติการสร้าง - egdata.app`)
};

const ja_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成統計 - egdata.app`)
};

const zh_cn2_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作统计 - egdata.app`)
};

const zh_hant1_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`創作統計 - egdata.app`)
};

const ko_stats_creations_meta_title = /** @type {(inputs: Stats_Creations_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 통계 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Creations stats - egdata.app" |
*
* @param {Stats_Creations_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_meta_title = /** @type {((inputs?: Stats_Creations_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_meta_title(inputs)
	if (locale === "ms") return ms_stats_creations_meta_title(inputs)
	if (locale === "da") return da_stats_creations_meta_title(inputs)
	if (locale === "de") return de_stats_creations_meta_title(inputs)
	if (locale === "en-US") return en_us2_stats_creations_meta_title(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_meta_title(inputs)
	if (locale === "fil") return fil_stats_creations_meta_title(inputs)
	if (locale === "fr") return fr_stats_creations_meta_title(inputs)
	if (locale === "it") return it_stats_creations_meta_title(inputs)
	if (locale === "hu") return hu_stats_creations_meta_title(inputs)
	if (locale === "nl") return nl_stats_creations_meta_title(inputs)
	if (locale === "no") return no_stats_creations_meta_title(inputs)
	if (locale === "pl") return pl_stats_creations_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_meta_title(inputs)
	if (locale === "pt") return pt_stats_creations_meta_title(inputs)
	if (locale === "ro") return ro_stats_creations_meta_title(inputs)
	if (locale === "fi") return fi_stats_creations_meta_title(inputs)
	if (locale === "sv") return sv_stats_creations_meta_title(inputs)
	if (locale === "vi") return vi_stats_creations_meta_title(inputs)
	if (locale === "tr") return tr_stats_creations_meta_title(inputs)
	if (locale === "cs") return cs_stats_creations_meta_title(inputs)
	if (locale === "bg") return bg_stats_creations_meta_title(inputs)
	if (locale === "ru") return ru_stats_creations_meta_title(inputs)
	if (locale === "uk") return uk_stats_creations_meta_title(inputs)
	if (locale === "ar") return ar_stats_creations_meta_title(inputs)
	if (locale === "hi") return hi_stats_creations_meta_title(inputs)
	if (locale === "th") return th_stats_creations_meta_title(inputs)
	if (locale === "ja") return ja_stats_creations_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_meta_title(inputs)
	return ko_stats_creations_meta_title(inputs)
});
export { stats_creations_meta_title as "stats.creations.meta.title" }